import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let CurriculumObjectiveService = {};

((CurriculumObjectiveService) =>
{
  CurriculumObjectiveService.getAllCurriculumCategories = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/curriculum_categories"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  CurriculumObjectiveService.getAllCurriculumObjectives = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/curriculum_objectives"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

})(CurriculumObjectiveService);

module.exports = CurriculumObjectiveService;



// WEBPACK FOOTER //
// ./app/js/services/curriculum-objective-service.js